// @flow
import { EventEmitter } from "fbemitter";
import { doLater } from "utils/domUtils";

/**
 * composes Event Emitter functions (on, once, off) into provided objects
 * @param obj
 * @returns {Object}
 */
export default (obj: ?Object) : any => {
	obj = obj || {};

	const em = new EventEmitter();

	obj.emit = (type: string, ...args: any) => {
		doLater(() => em.emit(type, ...args), 1); // turn event emitting into async flow
		return obj;
	};

	obj.on = (type: string, listener: Function) => {
		em.addListener(type, listener);
		return obj;
	};

	obj.once = (type: string, listener: Function) => {
		em.once(type, listener);
		return obj;
	};

	obj.off = (type: string) => {
		em.removeAllListeners(type);
		return obj;
	};

	return obj;
};
